/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description nearby reducers
 */

import { nullReducer, payloadKeyReducer } from '@zcode/reducers'
import type { NearbyWithMeta } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { CLEAR_NEARBY, RECEIVE_NEARBY } from '../constants/index'
import { meta } from './meta'
import type { ActionTypes } from './types'

const nearbyReducer = combineReducers<NearbyWithMeta, ActionTypes>({
  data: handleActions<NearbyWithMeta['data'], ActionTypes>(
    {
      [CLEAR_NEARBY]: nullReducer,
      [RECEIVE_NEARBY]: payloadKeyReducer('nearby'),
    },
    null
  ),
  meta,
})

export default nearbyReducer
